import axios from './axiosInstance';

const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};


const GetSettings=() => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.get(`/settings/get`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const SetSettings=({token,settings}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/settings/set`,settings)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


export {
    GetSettings,
    SetSettings
}


